module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "halftitle"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm10_half1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("BARBARA JORDAN")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0xvi-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figcap"
  }, [_vm._v("Jordan at her desk during her first term in the Texas Senate. Photo courtesy of Barbara Jordan Archives, Robert James Terry Library, Texas Southern University, Houston.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0938e24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm10_half1.vue
// module id = 87
// module chunks = 0